<template>
  <div class="login">
    <!-- 头部 -->
    <div class="login-top">
      <img src="@/assets/img/login/logo.png" alt v-show="!$Cookie.getCookie('beforeLoginLogo')" />
      <img height="30px" :src="$Cookie.getCookie('beforeLoginLogo')" alt v-show="$Cookie.getCookie('beforeLoginLogo')" />
      <p @click="toHome">首页</p>
    </div>
    <div class="login-body " @click="gotoFn">
      <div class="login-footer pf" style=" bottom:10px;">&reg; 2014-2025 杭州云智互联科技有限公司</div>
    </div>
    <!-- <login-animate></login-animate> -->
    <!-- 表单 -->
    <div class="login-con">
      <h1>即刻加入维护大师开启轻松工作之旅</h1>
      <!-- 登录表单 -->
      <login-form ref="loginForm" :showLogin="showLogin" @showQrcodeBox="showQrcodeBox"
        @showRegisteredForm="showRegisteredForm" @showWxLogin="showWxLogin" @showLoginCode="showLoginCode"></login-form>
      <!-- 微信 -->
      <wxCode ref="wxCode" :showWx="showWx" @showLoginForm="showLoginForm" @showQrcodeBox="showQrcodeBox"></wxCode>
      <!-- 扫码登录 -->
      <qrCode ref="qrCode" :showQr="showQr" @showRegisteredForm="showRegisteredForm" @showLoginForm="showLoginForm"
        @showWxLogin="showWxLogin"></qrCode>
      <!-- 注册表单 -->
      <registerForm ref="registerForm" :showRegister="showRegister" @showLoginForm="showLoginForm"></registerForm>
    </div>
    <!-- 底部 -->
  </div>
</template>
<script>
import PAGE_API from '@/apis/pageApi';
import loginAnimate from './loginAnimate';
import loginForm from './loginForm';
import registerForm from './registerForm';
import qrCode from './qrCode';
import wxCode from './wxCode';
export default {
  name: 'login',
  components: {
    loginAnimate,
    loginForm,
    qrCode,
    wxCode,
    registerForm
  },
  data () {
    return {
      showWx: false,
      showQr: true,
      showQrCode: true,
      showLogin: false, // 显示登录表单
      showRegister: false, // 显示注册表单
      codeModel: false, // 显示验证码弹框
      form: {
        username: '',
        password: '',
        passport_name: '',
        passport_password: '',
        passportMobile: '',
        passportCode: '',
        code: '',
        phone: '',
        smsCode: ''
      }
    };
  },
  methods: {
    gotoFn(){
      // window.open('https://www.clxp.net.cn/thread-42250-1-1.html')
      window.open('https://www.clxp.net.cn/thread-42749-1-1.html')
    },
    // 去登录页
    toLogin () {
      this.$router.push({
        path: 'login'
      });
    },
    // 去重置密码页
    toReset () {
      this.$router.push({
        path: PAGE_API.reset.path
      });
    },
    // 显示微信登录
    showWxLogin () {
      // this.$Message.error('微信登录暂时维护中！')
      // return
      this.$refs.wxCode.wxLogin();
      this.showLogin = false;
      this.showRegister = false;
      this.showWx = true;
      this.showQr = false;
    },
    // 显示注册框
    showRegisteredForm () {
      this.showWx = false;
      this.showLogin = false;
      this.showQr = false;
      this.showRegister = true;
    },
    // 显示登录框
    showLoginForm () {
      this.showQr = false;
      this.showWx = false;
      this.showRegister = false;
      this.showLogin = true;
    },
    // 显示扫码登录框
    showQrcodeBox () {
      this.$refs.qrCode.reloadPollCode();
      // this.$refs.qrCode.qrFail()
      this.showQrCode = true;
      this.showLogin = false;
      this.showRegister = false;
      this.showWx = false;
      this.showQr = true;
    },
    showLoginCode (data) {
      this.form.username = data;
      this.$refs.imgcodeModal.show();
    },
    toHome () {
      window.location.href = '/';
    },
    urlNo () {
      if (this.$route.query.registerNo == 1) {
        this.showRegisteredForm();
      }
    }
  },
  mounted () {
    this.$refs.wxCode.wxLogin();
    this.urlNo();
  }
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 110%;
  background-color: #1f2326;
  background-size: cover;
  background-position: center;

  // 头部
  .login-top {
    position: fixed;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 60px;
    background-color: #1f2326;
    border-bottom: 1px solid #63636b;
    z-index: 3;

    // 头部logo
    img {
      margin-left: 30px;
    }

    // 头部右侧字体
    p {
      margin-right: 20px;
      font-size: 15px;
      color: #fff;
      font-weight: bold;
      cursor: pointer;
    }

    p:hover {
      color: #00c2de;
    }
  }

  // 登录页背景
  .login-body {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0px;
    width: 100%;
    height: 100%;
    background: url(../../assets/img/login/v2.1.jpg) no-repeat;
    background-color: #1f2326;
    background-size: cover;
  }

  // 表单
  .login-con {
    position: absolute;
    right: 15%;
    top: 50%;
    transform: translateY(-60%);
    width: 380px;
    height: 440px;

    h1 {
      margin-bottom: 50px;
      font-size: 23px;
      color: #fff;
      font-weight: bold;
      text-align: center;
    }
  }

  // 底部
  .login-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 60px;
    text-align: center;
    line-height: 60px;
    font-size: 16px;
    color: #fff;
  }
}

html {
  overflow-x: scroll;
}
</style>
